import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';
import { grey } from './colors';

export const border = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['border'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          prominent: unityLightTokens['--border-color-bold'],
          subtle: unityLightTokens['--border-color-default'],
        }
      : {
          prominent: unityDarkTokens['--border-color-bold'],
          subtle: unityDarkTokens['--border-color-default'],
        };
  }

  return mode === 'light'
    ? {
        prominent: grey[300],
        subtle: grey[150],
      }
    : {
        prominent: grey[600],
        subtle: grey[850],
      };
};
